import { RequestResponse } from '../../../../../core/application/http-response/http-response';
import {
  HttpClient,
  HttpMethod
} from '../../../../../core/application/protocols/http-client';
import { ServiceCommand } from '../../../../../core/domain/command/service-command';
import { error, success } from '../../../../../core/domain/either/either';

export interface ConfirmEmailCodeModel {
  email: string;
  code: string;
}

export interface ConfirmEmailCodeResponse {
  accessToken: string;
  refreshToken: string;
  onboardingStep: string;
}

export class ConfirmEmailCode
  implements ServiceCommand<ConfirmEmailCode.Response>
{
  constructor(
    private readonly httpClient: HttpClient<ConfirmEmailCode.Response>,
    private readonly url: string
  ) {}

  async execute(
    params: ConfirmEmailCode.Params
  ): Promise<ServiceCommand.Response<ConfirmEmailCode.Response>> {
    const httpResponse = await this.httpClient.request({
      method: HttpMethod.POST,
      url: this.url,
      body: params
    });

    const responseOrError = RequestResponse.handle(httpResponse);

    if (responseOrError.isError()) {
      return error(responseOrError.value);
    }
    const response = responseOrError.value.response;

    return success(response);
  }
}

export namespace ConfirmEmailCode {
  export type Params = ConfirmEmailCodeModel;

  export type Response = ConfirmEmailCodeResponse;
}
